import * as React from "react";

import ScheduleCreate from "./../../components/Schedule/ScheduleCreate";

const ScheduleCreatePage: React.FC = () => <ScheduleCreate />;

export default ScheduleCreatePage;
